import { splitTextToLines } from './splitTextToLines'

/**
 * Truncate text to fit within a specified width and number of lines.
 * A CanvasRenderingContext2D is used to measure text width.
 * The truncated text, with appended ellipsis if necessary, is returned.
 */
export function truncateText(
  ctx: CanvasRenderingContext2D,
  text: string,
  maxWidth: number,
  maxLines: number,
): string {
  return splitTextToLines(ctx, text, maxWidth, maxLines).join(' ')
}
